<template>
  <DBox :id="'cmp-catalog-product-sidewindow-stocks'" :addButton="false" :addLink="false">
    <div class="ut-fh">
      <NTable class="dbox1" id="catalog-releases-sidewindow-related_tracks" :config="tableConfig" :headers="Headers"
        :items="list" height="170px">
        <template v-slot:item="{ item, tdcon }">
          <tr>
            <td v-bind="tdcon('account')">
              <div @click="onExport(item)" class="container-flex">
                <span class="txtov ut-link ut-text-accent5">{{
                  item["account_name"]
                }}</span>
                <img src="static/icons/doc.png" class="dt-icon s2" style="border-radius: 0px" />
              </div>
            </td>
            <td v-bind="tdcon('shipped')">
              <span class="txtov text-right">{{
                item["product_shipped"]
              }}</span>
            </td>
            <td v-bind="tdcon('net_sales')">
              <span class="txtov text-right">{{ item["product_sales"] }}</span>
            </td>
            <td v-bind="tdcon('inventory')">
              <span class="txtov text-right">{{ item["product_stock"] }}</span>
            </td>
            <td v-bind="tdcon('available_qty')">
              <span class="txtov text-right">{{ item["product_stock"] }}</span>
            </td>
            <td v-bind="tdcon('options')">
              <div class="dt-icon-container">
                <img src="static/icons/edit-blue.svg" class="dt-icon v5 s1" @click="(e) => onEditStock(item)"
                  :alt="$t('edit')" :title="$t('edit')" />
              </div>
            </td>
          </tr>
        </template>
      </NTable>
    </div>
    <!-- <div
        style="min-height: 48px; padding-right: 20px"
        class="ut-flex ut-jend"
      >
        <div>
          <span style="color: var(--text-secondary)">Total Stock : </span>
          <b>{{ totalStock }}</b>
        </div>
      </div> -->
    <template slot="bottomRight">
      <div class="ut-flex ut-fh ut-mr-10px">
        <div style="color: var(--text-secondary)">{{ $t("total_stock") }}:</div>
        <div style="min-width: 40px; text-align: right">
          <b>{{ totalStock }}</b>
        </div>
      </div>
    </template>
  </DBox>
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "../../../../plugins/datatable";
import { ProductsService } from "../../services/products.service";
import FileDownload from "js-file-download";

export default {
  props: {
    selectedProductDetails: {
      type: Object,
    },
  },
  components: {
    NTable,
    DBox,
  },
  data: function () {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
      }),
    };
  },
  computed: {
    Headers: function () {
      return [
        createTableHeader("account", { f: 2 }),
        createTableHeader("shipped", { f: 0.5, ta: "right" }),
        createTableHeader("net_sales", { f: 0.5, ta: "right" }),
        createTableHeader("inventory", { f: 0.5, ta: "right" }),
        createTableHeader("available_qty", { f: 0.5, ta: "right" }),
        createTableHeader("options", { mw: 30, text: false }),
      ];
    },

    totalStock: function () {
      // if (this.list.length > 0) {
      //   return this.list.reduce((acc, cur) => {
      //     return acc + parseInt(cur["product_stock"]);
      //   }, 0);
      // }
      // return 0;
      return this.selectedProductDetails.total_stock || 0;
    },

    list: function () {
      if (this.selectedProductDetails && this.selectedProductDetails.accounts_stock) {
        this.selectedProductDetails.accounts_stock = this.selectedProductDetails.accounts_stock.map(s => {
          s.product_shipped = s.product_shipped == '0' ? null : s.product_shipped;
          s.product_sales = s.product_sales == '0' ? null : s.product_sales;
          s.product_stock = s.product_stock == '0' ? null : s.product_stock;
          return s;
        });
      }

      return this.selectedProductDetails.accounts_stock || [];
    },
  },

  methods: {
    onExport: async function (item) {
      const res = await ProductsService.exportTAccounts(
        this.selectedProductDetails.product.product_id,
        item.account_id
      );
      FileDownload(res.data, `${item.account_name}.xlsx`);
    },
    onEditStock: function (item) {
      //console.log("WE",item);
      this.$emit("editStockModal", item);
    },

    onAddGenres: function () {
      //        this.$router.push({
      //   ...this.$route,
      //   query: {
      //     modal: "add_manufacture",
      //     external_id:this.selectedProductDetails.product.product_id,
      //   },
      // });
    },
  },
};
</script>
<style lang="scss">
.cmp-catalog-product-sidewindow-stocks {
  .container-flex {
    display: flex;
    align-items: center;

    span {
      flex: 1;
      padding-right: 3px;
    }

    // img {
    //   flex: 0.1;
    // }
  }

  .dt-ntable {
    // --ntable-height: 170px;
  }

  .i-icon-box {
    background-color: var(--emerald);
    color: white;
    font-weight: 400;
    display: grid;
    place-items: center;
  }
}
</style>
